import { z } from 'zod';
export const employeeRangeSchema = z.enum(['1-5', '6-20', '21-50', '51-200', '201+']);
